import { render, staticRenderFns } from "./BaseNewBindingDoorphone.vue?vue&type=template&id=5e03edaa&scoped=true"
import script from "./BaseNewBindingDoorphone.vue?vue&type=script&lang=js"
export * from "./BaseNewBindingDoorphone.vue?vue&type=script&lang=js"
import style0 from "./BaseNewBindingDoorphone.vue?vue&type=style&index=0&id=5e03edaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03edaa",
  null
  
)

export default component.exports